import { RoutePaths, RoutePathsWithId, RouteQueryStringKeys } from "./consts";

function getWorkspacePrefix(): string {
  const match = /\/workspace\/[\w-]+/.exec(window.location.pathname);
  return match ? match[0] : "";
}

export function createWorkflowRoute(workflowId: number): string {
  return `${getWorkspacePrefix()}${RoutePathsWithId.WORKFLOW}/${workflowId}`;
}

export function getRouteToActionItem(taskUuid: string) {
  return `?${RouteQueryStringKeys.TASK_ID}=${taskUuid}`;
}

export function getRouteToWorkflowActionItem(workflowId: number, taskUuid: string) {
  return `${createWorkflowRoute(workflowId)}${getRouteToActionItem(taskUuid)}`;
}

export function getRouteToWorkflowActionItemComment(workflowId: number, taskUuid: string, commentId: number) {
  return `${createWorkflowRoute(workflowId)}${getRouteToActionItemComment(taskUuid, commentId)}`;
}

export function getRouteToActionItemComment(taskUuid: string, commentId: number) {
  return `?${RouteQueryStringKeys.TASK_ID}=${taskUuid}&${RouteQueryStringKeys.COMMENT_ID}=${commentId}`;
}

export function getRouteToFields() {
  return getWorkspaceRouteTo(RoutePaths.CUSTOM_FIELDS);
}

export function getRouteToFormsPublished() {
  return getWorkspaceRouteTo(RoutePaths.SPECTRUM_FORMS);
}

export function getRouteToWorkflow(workflowId: number) {
  return getRouteWithId(RoutePathsWithId.WORKFLOW, workflowId);
}

export function getRouteToWorkflowTemplate(workflowTemplateId: number) {
  return getRouteWithId(RoutePathsWithId.BLUEPRINTS, workflowTemplateId);
}

export function getRouteToFormBuilder(queryParams: {
  formUuid: string;
  isPublic?: boolean;
  displayMode?: "page" | "panel";
}): string {
  const path = getWorkspaceRouteTo(RoutePaths.SPECTRUM_FORM_BUILDER);
  const searchParams = new URLSearchParams();

  searchParams.set(RouteQueryStringKeys.UUID, queryParams.formUuid);

  if (queryParams.isPublic) {
    // TODOTABLES (clewis): According to Haobo we can remove this since it's no longer used.
    searchParams.set(RouteQueryStringKeys.IS_PUBLIC, "1"); // (clewis): "1" indicates true
  }
  if (queryParams.displayMode != null) {
    searchParams.set(RouteQueryStringKeys.DISPLAY_MODE, queryParams.displayMode);
  }

  return `${path}?${searchParams.toString()}`;
}

export function getWorkspaceRouteTo(routePath: string) {
  return `${getWorkspacePrefix()}${routePath}`;
}

function getRouteWithId(route: RoutePathsWithId, id: number) {
  return `${getWorkspacePrefix()}${route}/${id}`;
}

export const maybeRemoveFirstSlash = (path: string) => {
  return path.startsWith("/") ? path.slice(1) : path;
};
